import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./Arrow.styled";

function Arrow() {
  const { tokens } = useDesignTokens();
  const { tooltip } = tokens;

  const height = parseInt(tooltip.arrow.height);
  const width = parseInt(tooltip.arrow.width);

  return (
    <S.Arrow style={{ width: width, height: height }}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <path d={`M0 0 L${height} ${height} L${width} 0`} />
      </svg>
    </S.Arrow>
  );
}

export default Arrow;
